/**
 * Created by marlon.jerez on 19/07/2016.
 */

import LatLngBounds = google.maps.LatLngBounds;
import GMap = google.maps.Map;
import LatLng = google.maps.LatLng;
import Marker = google.maps.Marker;
import PlaceSearchPagination = google.maps.places.PlaceSearchPagination;
import InfoWindow = google.maps.InfoWindow;

export class markerWraper{
	marker:Marker;
	infowindow:InfoWindow;
	content:string;
	constructor(store,map){
		//console.log(store);
		let position =  new LatLng(store.store_location_gmap.lat,store.store_location_gmap.lng);
		this.marker = new google.maps.Marker({
			position: position,
			map: map,
			icon: window.MARKERS_ICON
		});
		this.content = `<div class="store_info"><h4 class="store_info_title">${store.store_name}</h4>
						<p>${store.store_location_gmap.address}</p>
						<p><a href="${store.store_permalink}" class="btn btn-Red">View Store</a>
						</div>`;
		this.infowindow = new google.maps.InfoWindow({
			content: this.content
		});
		this.marker.addListener('click', ()=> {
			this.infowindow.open(map, this.marker);
		});
	}

	getPosition():LatLng{
		return this.marker.getPosition();
	}
}
